module.exports = __webpack_public_path__ + "img/windows.a36adb67.svg";